import { useQuery } from '@tanstack/react-query';
import { usePrismAuth } from '@/lib/prism-bridge';
import { getAppVersions } from './versions';
import { queryKeys } from './queryKeys';

/**
 * Versions of one app (GET /dev-portal/apps/{appId}/versions), with a per-shard state map.
 * Org-scoped query key. Gated on `isReady` (token + org id both synced from Prism) and the
 * appId — firing before the org id lands would 400 and show an error/retry page.
 */
export function useAppVersions(appId: string) {
  const { token, orgId, isReady } = usePrismAuth();
  return useQuery({
    queryKey: queryKeys.apps.versions(orgId, appId),
    queryFn: () => getAppVersions({ token, orgId }, appId),
    enabled: isReady && Boolean(appId),
  });
}
